import colors from "../../../constants/colors";

interface CircularProgressBarProps {
  percentage: number;
}

export default function CircularProgressBar({
  percentage,
}: CircularProgressBarProps) {
  const circumference = 2 * Math.PI * 65;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background Circle */}
      <circle
        cx="75"
        cy="75"
        r="65"
        stroke="#F0F3F9"
        strokeWidth="15"
        fill="none"
      />

      {/* Foreground Progress Circle */}
      <circle
        cx="75"
        cy="75"
        r="65"
        stroke={colors.complete}
        strokeWidth="15"
        fill="none"
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform="rotate(-90, 75, 75)"
        style={{
          transition: "stroke-dashoffset 0.5s ease-out",
        }}
      />

      {/* Center Text */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        className="fill-display-body"
        fontSize="28"
        fontWeight="bold"
      >
        {percentage}%
      </text>
    </svg>
  );
}
